export default "__VITE_ASSET__e9c59f71__"